/** @format */

import { Container } from "../../components/layouts/Container";
import {
  DashboardBarElement,
  DashboardBoxElement,
  DashboardMessageElement,
  DashboardLowerWrapper,
} from "../../components/ui_elements";
import useDashboardHooks from "../../hooks/useDashboardHooks";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";
import usePdfDownloadHooks from "../../hooks/usePdfDownloadHooks";
import ErrorBoundary from "../../api/ErrorBoundary";

const DashBoard = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const { pdfDownloadHandler, userStatus } = usePdfDownloadHooks();
  const {
    status,
    beforeStatus,
    step,
    errorStep,
    buttonPhrase,
    mainMessage,
    canceledFlag,
    moveToStart,
    moveToUseStart,
    moveToExamination,
    moveToUseStartPrecautions,
  } = useDashboardHooks(navigateByAgent);

  const background = "white";
  const align = "top";
  const fullwidth = true;

  return (
    <ErrorBoundary>
      <Container background={background} align={align} fullwidth={fullwidth} isLogin isInquiry>
        <DashboardMessageElement mainMessage={mainMessage} step={step} />
        <DashboardLowerWrapper>
          <DashboardBoxElement
            status={status}
            step={step}
            errorStep={errorStep}
            buttonPhrase={buttonPhrase}
            canceledFlag={canceledFlag}
            moveToStart={moveToStart}
            moveToUseStart={moveToUseStart}
            moveToExamination={moveToExamination}
            moveToUseStartPrecautions={moveToUseStartPrecautions}
          />
          <DashboardBarElement
            pdfDownloadHandler={pdfDownloadHandler}
            userStatus={userStatus}
            beforeStatus={beforeStatus}
          />
        </DashboardLowerWrapper>
      </Container>
    </ErrorBoundary>
  );
};

export default DashBoard;
